//import React from 'react'
import { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import PropTypes from "prop-types";
import iconoExcel from "../assets/iconoExcel.png";
import axios from "axios";
import { myURL } from "../assets/enviroment.js";
import ExportJsonExcel from "js-export-excel";
import { Spinner } from "react-bootstrap";
//import e from "express";

export const myId = () => {
  let id = [];
  let base = "0123456789ABCDEF";

  for (let i = 0; i < 8; i++) {
    let numero = (Math.random() * 15).toFixed(0);
    id.push(base[numero]);
  }
  return id.join("");
};

/*
APT_APTOS_ID:2176
APT_CAJERO:"TI Ecommerce"
APT_DATESEND:null
APT_ENTRY_SAP:59551316
APT_ENTRY_SAP_VENTA:null
APT_FECHA:"2023-09-09T00:00:00.000Z"
APT_FECHA_HORA:"2023-09-09T11:55:27.000Z"
APT_ID:14564021
APT_ID_CAJERO:"999999"
APT_IMPACTADO_SAP:null
APT_IMPORTE_SAP:null
APT_JURISDICCION:"ESTANDAR"
APT_STATUSSINCRO:null
APT_STATUS_MP:null
APT_SUCURSAL_ID:"T0176"
APT_TAX_JURISDICTION:"MEX04"
APT_TICKET:"0217609000289090923"
APT_TIPO_TRANSACCION:"VTA"
APT_VENTA_ORIGINAL:""
  */

// Removed unused import statement

const ResultTable = ({ dataTiendas }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState([]);
  const [loaded, setLoaded] = useState([]);
  const [error, setError] = useState(false);
  useEffect(() => {
    if (dataTiendas?.length > 0) {
      //console.log("dataTiendas:..", dataTiendas);
      let tempArray = [];
      dataTiendas.forEach((tienda) => {
        tempArray = [...tempArray, ...tienda.listTransactions];
      });
      //console.log("tempArray(data):..", tempArray);
      setData(tempArray);
    }
  }, [dataTiendas]);
  useEffect(() => {
    //console.log("data(Datos destruccturados):..", data);
    setLoaded([]);
    setLoading([]);
    setError(false);
  }, [data]);

  const createExcel = (dataSnapshot, tienda, fecha) => {
    console.log("dataSnapshot(creando Excel):..", dataSnapshot.length);

    let columnWidthsArray = [];
    let keysLength = Object.keys(dataSnapshot[0]).length;

    for (let i = 0; i <= keysLength; i++) {
      columnWidthsArray.push(15);
    }

    let option = {};

    option.fileName = `consultaSnapshot_${tienda}_${fecha}`;

    option.datas = [
      {
        sheetData: [...dataSnapshot],
        sheetName: "dataSnapshot",
        sheetFilter: Object.keys(dataSnapshot[0]),
        sheetHeader: Object.keys(dataSnapshot[0]),
        columnWidths: [...columnWidthsArray],
      },
    ];

    const toExcel = new ExportJsonExcel(option); //new
    toExcel.saveExcel(); //guardando
    console.log("Ya deberia de existir el archivo:..", toExcel);

    if (toExcel) {
      return { msg: "Creando Excel" };
    }
    //return {msg:'Creando Excel'}
  };

  const handleSnapshot = async (el) => {
    try {
      const tienda = String(el.APT_APTOS_ID).slice(1, 4);
      const fecha = el.APT_FECHA_HORA.slice(0, 10);
      console.log("tienda,fecha:..", tienda, fecha);
      //consultar datos en el backend
      setLoading([...loading, `${String(el.APT_APTOS_ID)}`]);
      const response = await axios.get(
        `${myURL}snapshotInHana/${tienda}/${fecha}`
      );
      console.log("response:..", response);
      if (response?.status === 200) {
        //alert("Snapshot generado correctamente");
        const dataSnapshot = response?.data?.getDataSnapshot;
        if (dataSnapshot?.length === 0 || !dataSnapshot || dataSnapshot?.error) {
          setLoading((prev) =>prev.filter((item) => item !== String(el.APT_APTOS_ID)));
          setError(true);
          return;
        }
        const exportData = createExcel(dataSnapshot, el.APT_APTOS_ID, fecha);
        if (exportData?.msg) {
          //alert(exportData?.msg);
          //setLoading([...loading.filter((item) => item !== el.APT_APTOS_ID)]);
          setLoading((prev) =>
            prev.filter((item) => item !== String(el.APT_APTOS_ID))
          );
          //setLoaded([...loaded, el.APT_APTOS_ID]);
          setLoaded((prev) => [...prev, el.APT_APTOS_ID]);
        }
        console.log("exportData:..", exportData);
      } else {
        setLoading((prev) =>prev.filter((item) => item !== String(el.APT_APTOS_ID)));
        setError(true);
      }
    } catch (error) {
      console.log("Error al generar el snapshot:..", error);
      setLoading((prev) =>prev.filter((item) => item !== String(el.APT_APTOS_ID)));
      setError(true);
    }
  };

  if (data.length > 0) {
    //console.log("renderizado correcto:..");
    return (
      <Table striped bordered hover responsive className="ms-1">
        <thead>
          <tr>
            <th>Tienda</th>
            <th>Ultimo Ticket Venta Aptos</th>
            <th>Caja</th>
            <th>Transacción</th>
            <th>Fecha Aptos</th>
            <th>Estatus Carga SAP</th>
            <th>Total Ventas Aptos</th>
            <th>Total Notas Credito Aptos</th>
            <th>Total Ventas SAP</th>
            <th>Total Notas Credito SAP</th>
            <th>Generar Snapshot</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((el) => {
            const caja = String(el.APT_TICKET).slice(5, 7);
            const transaccion = String(el.APT_TICKET).slice(7, 13);
            //console.log("caja,transaccion:..", caja, transaccion);
            //console.log("el:..", el);
            return (
              <tr key={myId()}>
                <td>{el.APT_SUCURSAL_ID}</td>
                <td>{el.APT_TICKET}</td>
                <td>{caja}</td>
                <td>{transaccion}</td>
                <td style={{ width: "230px" }}>{el.APT_FECHA_HORA}</td>
                <td>{el.APT_ENTRY_SAP > 0 ? "Cargado" : "Pendiente"}</td>
                <td>{el.totalVentasAptos}</td>
                <td>{el.totalNCAptos}</td>
                <td>{el.totalVentasSAP}</td>
                <td>{el.totalNCSAP}</td>
                {error === true ? (
                  <td>
                    <h6 className="text-danger">Error al generar Snapshot</h6>
                  </td>
                ) : (
                  <td className="text-center">
                    {loading.find(
                      (item) => item === String(el.APT_APTOS_ID)
                    ) !== undefined &&
                    loaded.find((item) => item === el.APT_APTOS_ID) ===
                      undefined ? (
                      <Spinner animation="border" variant="success" />
                    ) : (
                      <button
                        onClick={() => handleSnapshot(el)}
                        className="btn btn-light"
                        disabled={
                          loaded.find((item) => item === el.APT_APTOS_ID) !==
                          undefined
                        }
                      >
                        <img width={"20px"} src={iconoExcel} alt="iconoExcel" />
                      </button>
                    )}
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  } else {
    return <div>No Data...</div>;
  }
};

ResultTable.propTypes = {
  dataTiendas: PropTypes.array.isRequired,
};

export default ResultTable;
